import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { ToastProps } from '../../types/ToastProps';

type UseToastNotificationReturnType = (args: ToastProps) => void;
export const useToastNotification = (): UseToastNotificationReturnType => {
  const viewCartStyle = {
    border: '1px solid white',
    padding: '10px 0',
    textDecoration: 'none',
    borderRadius: '16pt',
    width: '75px',
  };
  const imageContainer = {
    height: '85px',
    width: '85px',
    background: 'white',
  };
  const image = {
    maxHeight: '75px',
  };
  const [isHover, setIsHover] = useState(false);
  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const closeButton = {
    padding: '5px 15px 5px 5px',
    color: isHover ? '#949494' : 'white',
    borderColor: isHover ? 'transparent' : 'black',
  };
  const productNameStyle = {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  } as React.CSSProperties;
  const showToast = (props: ToastProps) => {
    const handleOnClick = (
      event: React.MouseEvent<HTMLAnchorElement, MouseEvent>,
    ) => {
      if (props.onClick) {
        event.preventDefault();
        event.stopPropagation();
        props.onClick();
      }
    };

    toast.custom(
      (t) => (
        <div
          className={`toast-notification-container ${
            t.visible
              ? props.toasterAnimation?.animateincss
              : props.toasterAnimation?.animateoutcss
          } 
                                        max-w-md 
                                        w-full 
                                        bg-black 
                                        rounded-3xl 
                                        pointer-events-auto 
                                        flex ring-1 
                                        ring-black 
                                        ring-opacity-5`}
          id={`${props.id}`}
        >
          <div className="flex-1 w-0 p-4">
            <div className="flex items-start">
              <div
                className="flex-shrink 
              flex-col 
              flex 
              items-center
              justify-center rounded-lg"
                style={imageContainer}
              >
                <img style={image} src={props.image} />
              </div>
              <div className="ml-3 mt-2 pr-3 flex-1">
                <p className="my-1 text-base font-bold text-white">
                  {props.header}
                </p>
                <p
                  className="my-1 text-sm text-white w-52"
                  style={productNameStyle}
                >
                  {props.message}
                </p>
                <p className="my-1 text-sm text-white">{props.subMessage}</p>
              </div>
              <div
                className="flex-shrink 
              flex-col 
              flex 
              items-center
              justify-center"
                style={{ height: '85px' }}
              >
                <a
                  href={props.link}
                  onClick={handleOnClick}
                  className="text-sm text-center text-white"
                  style={viewCartStyle}
                >
                  {' '}
                  {props.actionLabel}{' '}
                </a>
              </div>
            </div>
          </div>
          <div className="flex flex-col border-l border-gray-200">
            <button
              id="btn-close"
              className="w-full 
            bg-black 
            border 
            border-transparent 
            rounded-none 
            rounded-r-3xl 
            flex 
            items-end 
            justify-end                              
            text-sm font-medium 
            text-white"
              onMouseEnter={handleMouseEnter}
              onMouseLeave={handleMouseLeave}
              style={closeButton}
              onClick={() => toast.remove(t.id)}
            >
              x
            </button>
          </div>
        </div>
      ),
      {
        duration: props.duration ? props.duration : 30000,
      },
    );
  };
  return showToast;
};
